import React from "react";
import "../styles/pages/Help.css";

const plus = <span>«<b>+</b>»</span>;
const minus = <span>«<b>–</b>»</span>;

export function Help(props) {
    return (
        <div>
            <h4>Калькулятор расчета конституции человека по дате его рождения</h4>
            <div className="block-indent">
                <p className="paragraph-indent">
                    Известно, что энергии времени (час, день, месяц, год), присутствующие при рождении человека,
                    непосредственно влияют на его судьбу.
                    Астрология, ба цзы, нумерология, дизайн человека, матрица судьбы и т.д. – это те инструменты,
                    с помощью которых можно описать возможности человека и дать тот или иной прогноз судьбоносных дат и
                    периодов.
                </p>
                <p className="paragraph-indent">
                    Одним из таких способов, дающих достаточно достоверное описание внешнего отражения и внутреннего
                    содержания человека,
                    является понятие энергетической конституции человека, которая указывает на его индивидуальные
                    особенности: строение тела,
                    поведение, характер, склонности и потенциалы, состояние здоровья или болезни. Эта информация не
                    нова,
                    и почерпнуть эти знания можно как на просторах интернета, так и прослушав вебинары известных школ и
                    академий,
                    специализирующихся в области Китайской медицины.
                </p>
                <p className="paragraph-indent">
                    Уникальность данной методики основана на авторском методе преподавателей ассоциации <a
                    href="http://massageural.ru/">«Массажисты Урала»</a>.
                    Калькулятор позволяет математически рассчитать энергетическую конституцию человека, основываясь на
                    параметрах его даты рождения.
                </p>
                <p className="paragraph-indent">
                    В данной интерпретации для расчета энергетической конституции используется Китайский календарь.
                    Но основная цель данного расчета все же заключается не в описательной части конституциональных
                    особенностей человека,
                    а в возможности посмотреть на процессы, происходящие в теле человека с точки зрения его здоровья и
                    самочувствия.
                    Калькулятор подскажет, как аккуратно пройти свои не самые простые периоды. Не случайно на Востоке с
                    древнейших
                    времен первопричиной любых отклонений от гармоничного состояния считалось нарушение суточного ритма
                    циркуляции жизненной энергии.
                </p>
                <p className="paragraph-indent">
                    На нашем сайте вы имеете возможность выбрать режим расчета энергетической конституции человека: <a
                    href="/light">Ученик</a> и <a href="/expert">Эксперт</a>.
                    Отличие одного режима от другого определено количеством полезной информации, касающейся периодов
                    жизни человека,
                    а именно: расчет энергий внутреннего времени, анализ энергий внешнего времени, а в дальнейшем 
                    прогностические и рекомендательные функции.
                </p>
            </div>
            <h4>Схема расположения полей личной карты энергетической конституции человека</h4>
            <ul className="block-indent">
                <li><b>Исходные данные</b></li>
                <div>
                    Для расчета энергетической конституции человека выберите в календаре соответствующую дату
                    рождения.<br/>
                    <img src="https://i.ibb.co/b1F6Qj2/2020-01-07-15-06-23.png" alt="Выбор даты рождения"
                         className="block-indent-bottom"/><br/>

                    Выберите <a href="/help#birth-hour">час рождения</a> из выпадающего списка двенадцати животных традиционного Китайского
                    календаря.<br/>
                    <img src="https://i.ibb.co/ZL7LfG3/pick-birth-hour.png" alt="Выбор часа рождения"
                         className="block-indent-bottom"/><br/>
                    Под датой расчета понимается дата любого события, в том числе и текущая дата. Выберите в календаре
                    соответствующую дату.<br/>
                    <img src="https://i.ibb.co/6HvBWFS/pick-event-date.png" alt="Выбор даты расчета"
                         className="block-indent-bottom"/>
                </div>
                <li className="block-indent-bottom"><b>Характеристики даты рождения и даты расчета</b></li>
                <img src="https://i.ibb.co/GRCzjqH/date.png" alt="Дата рождения" className="block-indent-bottom"/>
                <div>
                    Дата рождения привязана к Китайскому календарю, где каждая ее составляющая (час, день, месяц и год)
                    имеет совершенно одинаковую структуру, и отражена на экране двумя знаками: Небесный Ствол (НС) и
                    Земная Ветвь (ЗВ).
                    Для удобства понимания НС и ЗВ имеют написание как в Китайском варианте (<a href="/help#hieroglyph">иероглиф</a>),
                    так и в русифицированном варианте (аббревиатура). В примере человек родился в год водяного Быка,
                    месяц водяной Собаки, день почвенного Кролика и час деревянной Крысы.
                </div>
                <ol className="block-indent-bottom">
                    <li>Название столбца по дате рождения</li>
                    <li>Стихия НС</li>
                    <li>Обозначение НС (иероглиф/аббревиатура)</li>
                    <li>Обозначение ЗВ (иероглиф/аббревиатура)</li>
                    <li>Название ЗВ</li>
                </ol>
                <img src="https://i.ibb.co/48skXzV/colors.png" alt="Соответствие цветов" className="block-indent-bottom"/>
                <div className="block-indent-bottom">
                    Цвет иероглифа/аббревиатуры НС и ЗВ соответствует его стихии.<br/>
                    Позиция {plus} или {minus} перед буквой в аббревиатуре НС и ЗВ определяет его полярность:<br/>
                    {plus} - полярность ЯН<br/>
                    {minus} - полярность ИНЬ
                </div>
                <div>
                    <div className="block-indent-bottom">
                        Дата расчета отличается от даты рождения отсутствием выбора часа.<br/>
                        В примере выбранная дата расчета 01.01.2020 пришлась на год почвенной Свиньи, месяц огненной Крысы и
                        день водяного Кролика.<br/>
                    </div>
                    <img src="https://i.ibb.co/GsWDcBd/event-Date.png" alt="Дата расчета" className="block-indent-bottom"/>
                </div>
                <li><b>Пентаграмма, определяющая энергетическую конституцию</b></li>
                <img src="https://i.ibb.co/Y8qwXV6/setup-pentagram.png" alt="Пентаграмма"/>
                <div className="block-indent-bottom">
                    Схематически энергетическую конституцию изображают в виде пентаграммы с {plus} и {minus}.
                    Всего существует 10 типов энергетических конституций. Традиционно верхушка пентаграммы принадлежит
                    стихии Огня.
                    Внутренний круг пентаграммы соответствует ИНЬ-параметрам. Внешний круг – ЯН-параметрам.
                    В нашем примере расчет показал, что человек принадлежит к энергетической конституции ян-Холод.
                </div>
                <li><b>Циклы энергий внутреннего времени на выбранную дату</b></li>
                <img src="https://i.ibb.co/kXPPfB8/inner-energy-cycles.png" alt="Циклы внутренних энергий" className="block-indent-bottom"/>
                <div className="block-indent-bottom">
                    <p className="paragraph-indent">
                        Человек в процессе своей жизни проходит различные периоды: детство, юность, становление, зрелость,
                        пожилой возраст и старость. Данная методика заимствована из работ профессора Пака Чжэ Ву.
                    </p>
                    <p className="paragraph-indent">
                        В данном формате будем называть период детства циклом энергии Ветра,
                        период юности циклом энергии Тепла, период становления циклом энергии Жара, период зрелости циклом
                        энергии Влажности, период пожилого возраста циклом энергии Сухости и период старости циклом энергии Холода.
                    </p>
                    <p className="paragraph-indent">
                        Каждый цикл характеризуется различной активностью, энергетическим и познавательным уровнем,
                        стремлением к достижению различных целей,
                        либо стремлением к тишине и покою, интересом или его отсутствием к различным событиям,
                        состоянием здоровья и скоростью излечения от болезней, недугов и иных повреждений организма.
                    </p>
                </div>
                <div>
                    Калькулятор показывает комбинацию циклов энергий внутреннего времени конкретного человека на любую
                    выбранную дату в соответствии с его датой рождения:                
                    <ol className="block-indent-bottom">
                        <li>Название энергий</li>
                        <li>Большой цикл</li>
                        <li>Годовой цикл</li>
                        <li>Сезонный цикл</li>
                        <li>Месячный цикл</li>
                        <li>Суточный цикл</li>
                    </ol>
                </div>
                <div className="block-indent-bottom">                    
                    Большой цикл содержит в себе отрезки времени с периодом в 12 лет: от энергии Ветра (0 лет) до
                    энергии Холода (72 года).
                    Каждые 12 лет цикл меняется. После 72 лет периоды времени вновь циклично переходят к энергии Ветра.
                    Недаром в народе говорят: «Что стар, что мал». Циклы от Годового до Суточного имеют структуру
                    Большого цикла и разбивают предыдущий на те же шесть равноценных отрезков для получения более
                    детализированной картины энергий внутреннего времени человека на выбранную дату расчета.
                </div>
                <li id="birth-hour"><b>Выбор часа</b></li>
                <div className="block-indent-bottom">
                    Выбор ЗВ часа рождения в нашем калькуляторе исполнен в виде выпадающего списка двенадцати животных
                    традиционного Китайского календаря.
                    В связи со сложностью расчетов и наличием большого количества уже разработанных калькуляторов,
                    которые определяют ЗВ часа рождения по введенному времени,
                    рекомендуем перейти на сайт <a
                    href="http://fengshui.su/v5/index.php?action=bazicalc&country=%D0%A0%D0%BE%D1%81%D1%81%D0%B8%D1%8F&town=%D0%9C%D0%BE%D1%81%D0%BA%D0%B2%D0%B0">Российской
                    академии фэншуй</a>:
                    <img src="https://i.ibb.co/bJtRhYs/academy-fengshui.jpg" alt="academy-fengshui" />
                </div>
                <div>
                    В появившейся информации после нажатия кнопки «Рассчитать» обратите внимание на <a href="/help#hieroglyph">иероглиф</a> часа рождения. Его вам и предстоит выбрать.
                </div>
                <img src="https://i.ibb.co/S3sfsVj/birth-hour.png" alt="Час рождения" className="block-indent-bottom"/>

                <div className="block-indent">
                    Если вы не смогли разобраться в представленном материале, то можете написать вопрос <a
                    href="mailto: klopovaog@yandex.ru">нам на почту</a>.
                    Специалист рассчитает ЗВ часа вашего рождения, если вы предоставите исчерпывающую информацию: час,
                    день, месяц, год и место рождения.
                    Данная операция не требует от вас финансовых затрат. По всем остальным вопросам, затрагивающим некую
                    конкретизацию, расшифровку, прогнозы и т.д.,
                    оставляем за собой право переходить на товарно-денежные отношения по услугам консультирования. В
                    случае обнаружения ошибок в расчетах, деталях,
                    текстах и т.д. просьба сообщать об этом по указанному выше адресу.
                </div>
                <h5 id="hieroglyph">Список используемых иероглифов</h5>
                <li>Небесные стволы</li>
                <img src="https://i.ibb.co/sCnw1Pg/sky-stems.png" alt="Небесные стволы" className="block-indent-bottom"/>
                <li>Земные ветви</li>
                <img src="https://i.ibb.co/kDY33Xx/earth-branches.png" alt="Земные ветви" className="block-indent-bottom"/>
            </ul>
        </div>
    )
}

export default Help;